export var EActionTypes;
/** Payload для фильтра адреса (геосаджест)*/

(function (EActionTypes) {
  EActionTypes["SET_ADDRESS"] = "MainFilters/SetAddress";
  EActionTypes["SET_ROOMS"] = "MainFilters/SetRooms";
  EActionTypes["SET_JK_ROOMS"] = "MainFilters/SetJkRooms";
  EActionTypes["SET_AREA"] = "MainFilters/SetArea";
  EActionTypes["SET_ERROR"] = "MainFilters/SetError";
  EActionTypes["SET_USER_AREA_FLAG"] = "MainFilters/SetUserAreaFlag";
  EActionTypes["SET_ESTIMATION_TARGET"] = "MainFilters/SetEstimationTarget";
  EActionTypes["SET_NEWBUILDING_ID"] = "MainFilters/SetNewbuildingId";
  EActionTypes["SET_HOUSE_ID"] = "MainFilters/SetHouseId";
  EActionTypes["RESET_FILTERS"] = "MainFilters/ResetFilters";
})(EActionTypes || (EActionTypes = {}));

/** Payload для установки ошибки */
export var ECurrentErrorField;

(function (ECurrentErrorField) {
  ECurrentErrorField["none"] = "";
  ECurrentErrorField["address"] = "address";
  ECurrentErrorField["roomsCount"] = "roomsCount";
  ECurrentErrorField["area"] = "area";
})(ECurrentErrorField || (ECurrentErrorField = {}));